/** Key value for share status between modules while fetching */
export enum FetchStatus {
  IDLE = 0,
  FETCHING = 1,
  SUCCESS = 2,
  ERROR = 3,
}

/** Key value for sharing custom error code between components */
export const CUSTOM_ERROR_INFO = {
  UNABLE_PAGE_RENDER: {
    errorCode: 'OM_XXX_OPPR00001',
    errorDescription: 'Unable to find page to render',
  },
  UNABLE_FETCH_CMS: {
    errorCode: 'OM_XXX_OPFC00001',
    errorDescription: 'Unable to fetch content from CMS',
  },
} as const

export const FIRMWARE_UPDATE_OPTIONS = {
  AUTO: 'auto',
  NOTIFY: 'notify',
} as const

export type FirmwareUpdateOptionType =
  (typeof FIRMWARE_UPDATE_OPTIONS)[keyof typeof FIRMWARE_UPDATE_OPTIONS]

export const SUPPLY_TYPES = {
  INK: 'ink',
  LASER: 'laser',
} as const

export type SupplyType = (typeof SUPPLY_TYPES)[keyof typeof SUPPLY_TYPES]

export const CARTRIDGE_TYPES = {
  DEFAULT: 'default',
  CIRCUITRY: 'circuitry',
  CHIP: 'chip',
} as const

export type CartridgeType =
  (typeof CARTRIDGE_TYPES)[keyof typeof CARTRIDGE_TYPES]

export const PRINTER_FUNCTION_TYPE = {
  MFP: 'MFP',
  SFP: 'SFP',
} as const

export type PrinterFunctionType =
  (typeof PRINTER_FUNCTION_TYPE)[keyof typeof PRINTER_FUNCTION_TYPE]

export const SCAN_SETUP_COOKIES = 'scanSetupComplete'
export const NEW_PRINTER_ADD_COOKIES = 'newPrinterAdded'

export const LASER_IO_REF = { DEFAULT: '76010', CHIP: '76005' } as const
export type LaserIoRefCode = (typeof LASER_IO_REF)[keyof typeof LASER_IO_REF]

export const PORTAL_LOCAL_STORAGE_KEY = 'portal-oobe'

export const WORKSPACE_TYPES = {
  BUSINESS_MPS_COMPANY: 'BusinessMPSCompany',
  CHANNEL_MPS_COMPANY: 'ChannelMPSCompany',
  BUSINESS_TRANSACTIONAL_SMB: 'BusinessTransactionalSMB',
  SUPPORT_FIELD_TECH: 'SupportFieldTech',
  DEVELOPER: 'Developer',
} as const

export const NEW_ORGANIZATION_VALUE = 'new_organization'
